import React, { useState } from 'react';

export default function StepSubmit({ form, onSuccess }) {
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async () => {
    if (loading || submitted) return;

    if (!form?.x || !form?.walletEth) {
      setStatus('Missing required fields');
      return;
    }

    setLoading(true);
    setStatus('Submitting...');

    try {
      const res = await fetch('/api/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          x: form.x,
          walletEth: form.walletEth,
          proofOfComment: form.proofOfComment || '',
        }),
      });

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { status: 'error', message: text };
      }

      if (data.status === 'success') {
        setSubmitted(true);
        setStatus('Submitted successfully ✓');
        onSuccess?.();
      } else if (data.status === 'duplicate') {
        setStatus('Already submitted ⚠️');
      } else {
        setStatus('Error: ' + (data.message || 'Unknown error'));
      }
    } catch (err) {
      console.error(err);
      setStatus('Network error ❌');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{
        fontFamily: "'Patrick Hand', cursive",
        fontSize: '26px', fontWeight: '900', color: '#2d2d2d',
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: '12px'
      }}>READY TO SUBMIT?</h2>

      {/* Summary of what will be stored */}
      <div style={{
        background: 'rgba(255,255,255,0.18)',
        border: '2px solid rgba(45,45,45,0.2)',
        borderRadius: '12px',
        padding: '14px 16px',
        marginBottom: '20px',
        textAlign: 'left'
      }}>
        <p style={{
          margin: '0 0 8px',
          fontSize: '11px', fontWeight: '800',
          color: '#2d2d2d', fontFamily: "'Patrick Hand', cursive",
          textTransform: 'uppercase', letterSpacing: '0.5px'
        }}>What we're recording:</p>
        <div style={{ fontSize: '12px', color: '#2d2d2d', fontFamily: "'Patrick Hand', cursive", lineHeight: '1.8' }}>
          <div>𝕏 &nbsp;<strong>{form.x}</strong></div>
          <div>ETH &nbsp;<strong style={{ wordBreak: 'break-all' }}>{form.walletEth}</strong></div>
          {form.proofOfComment && (
            <div>Comment &nbsp;<strong style={{ wordBreak: 'break-all' }}>{form.proofOfComment}</strong></div>
          )}
        </div>
      </div>

      {/* Privacy reassurance */}
      <p style={{
        fontSize: '11px',
        color: '#2d2d2d',
        fontFamily: "'Patrick Hand', cursive",
        marginBottom: '20px',
        lineHeight: '1.5'
      }}>
        🔒 Your data is stored securely and used only to allocate your whitelist spot.
        We will <strong>never</strong> ask for your seed phrase or private key.
      </p>

      <button
        onClick={submit}
        disabled={loading || submitted}
        style={{
          width: '100%', padding: '18px',
          background: submitted
            ? 'linear-gradient(180deg, #5cb85c 0%, #4cae4c 100%)'
            : loading
              ? '#8b8b8b'
              : 'linear-gradient(180deg, #5cb85c 0%, #4cae4c 100%)',
          border: '3px solid #2d2d2d',
          borderRadius: '12px',
          color: '#fff',
          fontSize: '18px', fontWeight: '900',
          fontFamily: "'Patrick Hand', cursive",
          textTransform: 'uppercase', letterSpacing: '2px',
          cursor: loading || submitted ? 'not-allowed' : 'pointer',
          transform: 'skewX(-5deg)',
          boxShadow: loading || submitted ? '0 2px 0 #2d2d2d' : '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)',
          opacity: loading ? 0.7 : 1,
          transition: 'all 0.1s ease',
          textShadow: '1px 1px 0 rgba(0,0,0,0.2)'
        }}
        onMouseDown={(e) => {
          if (loading || submitted) return;
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(4px)';
          e.currentTarget.style.boxShadow = '0 2px 0 #2d2d2d';
        }}
        onMouseUp={(e) => {
          if (loading || submitted) return;
          e.currentTarget.style.transform = 'skewX(-5deg) translateY(0)';
          e.currentTarget.style.boxShadow = '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)';
        }}
      >
        <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
          {loading ? 'SUBMITTING...' : submitted ? 'SUBMITTED ✓' : 'CONFIRM SUBMIT ✓'}
        </span>
      </button>

      {status && (
        <p style={{
          marginTop: 20,
          fontFamily: "'Patrick Hand', cursive",
          fontSize: '14px',
          color: '#2d2d2d',
          fontWeight: '700'
        }}>
          {status}
        </p>
      )}
    </div>
  );
}